// extracted by mini-css-extract-plugin
module.exports = {"Projects":"ProjectPage_Projects__3M1Jm"};